import { useMutation } from "@tanstack/react-query";
import type { CreateMerchantPayload } from "@unbox/api";
import { handleError } from "@/api/error";
import { queryClient } from "@/providers/QueryClientProviderWrapper";
import { client } from "../client";

export const useCreateMerchant = () => {
  return useMutation({
    mutationFn: async (payload: CreateMerchantPayload) => {
      const res = await client.admin.merchant.$post({
        json: payload,
      });
      if (!res.ok) throw await handleError(res);
      return await res.json();
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["admin", "merchants"] });
    },
  });
};
